import { ElCollapse, ElCollapseItem } from 'element-plus'
import { computed, defineComponent, h } from 'vue'

export default defineComponent({
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const value = computed({
      get: () => props.context._value,
      set: (val) => props.context.node.input(val),
    })
    // eslint-disable-next-line no-console
    console.log('collapse', props.context.attrs.attrs?.items)
    const isAccordion = computed(() => props.context.attrs?.accordion ?? false)

    return () =>
      h(
        ElCollapse,
        {
          modelValue: value.value,
          accordion: isAccordion.value,
          'onUpdate:modelValue': (val) => (value.value = val),
        },
        () =>
          (props.context.attrs?.attrs?.items || []).map((item) =>
            h(ElCollapseItem, { name: item.name, title: item.title }, { default: () => h('div', item.content) }),
          ),
      )
  },
})
